import cx from 'classnames';
import Loader from '../Loader/Loader';
import styles from './ButtonV2.module.scss';

export const ButtonV2 = ({ 
  children, 
  className, 
  variant = 'filled', // filled | outline | transparent
  color = 'primary', // primary | dark | white | dark-75
  iconBefore,
  iconAfter,
  loading,
  size,
  active,
  fullWidth,
  textClassName,
  hoverStyle, // 'secondary'
  smallPadding,
  as,
  rounded = true,
  borderRadius,
  style,
  ...rest
}) => {

  const rootClassName = cx(
    styles.root,
    className,
    loading && styles.loading,
    // size === 'xlg' && styles.xlg,
    // size === 'xs' && styles.xs,
    styles[`${size}Size`],
    active && styles.active,
    iconBefore && styles.withIconBefore,
    hoverStyle && styles[`${hoverStyle}HoverStyle`],
    fullWidth && styles.fullWidth,
    smallPadding && styles.smallPadding,
    styles[`${color}Color`],
    styles[`${variant}Variant`],
    !rounded && styles.notRounded,
  )


  const Component = as || 'button';

  return (
    <Component {...rest} style={{ borderRadius, ...style }} className={rootClassName}>
      <Loader loading={loading} position="absolute" color="inherit" size={22} thickness={2} />
      {iconBefore && <div className={styles.iconBefore}>{iconBefore}</div>}
      <span className={cx(styles.text, textClassName)}>{children}</span>
      {iconAfter && <div className={styles.iconAfter}>{iconAfter}</div>}
    </Component>
  )
}
